export * from './pager.component';
export * from './pager.module';
